import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ToastrNotificationService } from '@common/services/toastr-notification.service';
import { catchError, interval, of, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {
    private readonly checkIntervalMs = 5 * 1000;
    private readonly versionUrl = '/assets/imgtag.txt';
    private http = inject(HttpClient);
    private toastr = inject(ToastrNotificationService);
    private currentVersion: string | null = null;
    private started = false;
    private warned = false;

    start() {
        if (this.started) return;
        this.started = true;

        interval(this.checkIntervalMs)
            .pipe(
                switchMap(() => this.fetchVersion()),
                tap((version) => this.handleVersion(version))
            )
            .subscribe();

        this.fetchVersion()
            .pipe(tap((version) => this.handleVersion(version)))
            .subscribe();
    }

    private fetchVersion() {
        const cacheBuster = `ts=${Date.now()}`;
        const url = `${this.versionUrl}?${cacheBuster}`;
        return this.http.get(url, { responseType: 'text' }).pipe(catchError(() => of(null)));
    }

    private handleVersion(version: string | null) {
        if (!version) return;
        const normalized = version.trim();
        if (!normalized) return;

        if (this.currentVersion === null) {
            this.currentVersion = normalized;
            return;
        }

        if (this.currentVersion !== normalized && !this.warned) {
            this.warned = true;
            this.toastr.show({
                type: 'warning',
                message: 'A new version is available. Please reload the page.'
            }, {
                timeOut: 0,
                extendedTimeOut: 0,
                closeButton: true,
                tapToDismiss: false
            });
        }
    }
}
